import { render, staticRenderFns } from "./LayoutBottom.vue?vue&type=template&id=68f6ec20&scoped=true"
import script from "./LayoutBottom.vue?vue&type=script&lang=js"
export * from "./LayoutBottom.vue?vue&type=script&lang=js"
import style0 from "./LayoutBottom.vue?vue&type=style&index=0&id=68f6ec20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f6ec20",
  null
  
)

export default component.exports